export default "__VITE_ASSET__a$Qg4UvX__"